export default __webpack_public_path__ + "images/paymentBlockImg1.ec68c1c.png";